import { render, staticRenderFns } from "./PgtoAprovado.vue?vue&type=template&id=af7de98c&scoped=true&"
import script from "./PgtoAprovado.vue?vue&type=script&lang=js&"
export * from "./PgtoAprovado.vue?vue&type=script&lang=js&"
import style0 from "./PgtoAprovado.vue?vue&type=style&index=0&id=af7de98c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "af7de98c",
  null
  
)

export default component.exports